import React, { useEffect, useState } from "react";

import { get, pick } from "lodash";

import { LearnerDetailsProps, StateProviderProps } from "./types";
import { SnackbarKey, useSnackbar } from "notistack";
import LearnerDetails from "./LearnerDetails";
import LearnerDetailsModal from "./components/Modals/LearnerDetailsModal";
import useQueryLearnerDetails from "./hooks/useQueryLearnerDetails";

const StateProvider = ({ learnerId }: StateProviderProps) => {
  const { data, loading } = useQueryLearnerDetails(learnerId);
  const { closeSnackbar, enqueueSnackbar } = useSnackbar();

  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const learnerProps: LearnerDetailsProps = pick(get(data, "learner", {}), [
    "id",
    "personId",
    "name",
    "age",
    "address",
    "pickupAddress",
    "sourcedBy",
  ]);
  learnerProps.phoneNumber = get(
    data,
    "learner.mobileNumber",
    get(data, "learner.mobileNumber"),
  );

  useEffect(() => {
    let noActiveAddressNotificationKey: null | SnackbarKey = null;
    const noActiveAddress =
      !data?.learner?.pickupAddress && !data?.learner?.address;

    if (data?.learner && noActiveAddress) {
      noActiveAddressNotificationKey = enqueueSnackbar(
        "Learner has no active address",
        {
          variant: "error",
        },
      );
    }
    return () => {
      if (noActiveAddressNotificationKey) {
        closeSnackbar(noActiveAddressNotificationKey);
      }
    };
  }, [data?.learner?.pickupAddress, !data?.learner?.address]);

  const handleToggleLearnerDetailsModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <LearnerDetails
        loading={loading}
        onClick={handleToggleLearnerDetailsModal}
        {...learnerProps}
      />
      {isModalOpen && data.learner && !loading && (
        <LearnerDetailsModal
          learnerId={learnerProps.id}
          isOpen={isModalOpen}
          onToggleLearnerDetailsModal={handleToggleLearnerDetailsModal}
        />
      )}
    </>
  );
};

export default StateProvider;
